import { StateChangeEvent } from './types';

export function createStateChangeEvent(): StateChangeEvent {
	return {
		prev_patch: null,
		next_patch: null,
		ticker: [],
	};
}
